/**
 * Alerte « retour en stock » par SMS (Klaviyo) — page produit.
 *
 *  <restock-alert>  : bouton, affiché quand la variante choisie est épuisée
 *  <restock-modal>  : fenêtre de saisie du numéro (s'appuie sur <modal-dialog> de Release :
 *                     focus piégé, blocage du scroll, fermeture avec Échap / clic sur le fond)
 */
(function () {
  'use strict';

  var PRIO = ['US', 'CA', 'RU', 'GB', 'AU', 'NO', 'RE'];

  /* Liste de secours (si la bibliothèque n'est pas chargée) : ISO|Pays|Indicatif|Exemple */
  var BUILTIN = ('FR|France|33|7 12 34 56 78;BE|Belgium|32|470 12 34 56;CH|Switzerland|41|78 123 45 67;LU|Luxembourg|352|628 123 456;' +
    'DE|Germany|49|1512 3456789;ES|Spain|34|612 34 56 78;IT|Italy|39|312 345 6789;PT|Portugal|351|912 345 678;' +
    'GB|United Kingdom|44|7400 123456;IE|Ireland|353|85 012 3456;NL|Netherlands|31|6 12345678;AT|Austria|43|664 123456;' +
    'US|United States|1|201 555 0123;CA|Canada|1|506 234 5678;AU|Australia|61|412 345 678;NZ|New Zealand|64|21 123 4567;' +
    'SE|Sweden|46|70 123 45 67;NO|Norway|47|406 12 345;DK|Denmark|45|32 12 34 56;FI|Finland|358|41 2345678;' +
    'PL|Poland|48|512 345 678;CZ|Czechia|420|601 123 456;GR|Greece|30|691 234 5678;RO|Romania|40|712 345 678;' +
    'HU|Hungary|36|20 123 4567;BG|Bulgaria|359|48 123 456;HR|Croatia|385|91 234 5678;TR|Turkey|90|501 234 56 78;' +
    'MA|Morocco|212|650-123456;DZ|Algeria|213|551 23 45 67;TN|Tunisia|216|20 123 456;EG|Egypt|20|100 123 4567;' +
    'SN|Senegal|221|70 123 45 67;CI|Côte d\'Ivoire|225|01 23 45 67 89;CM|Cameroon|237|6 71 23 45 67;ZA|South Africa|27|71 123 4567;' +
    'AE|United Arab Emirates|971|50 123 4567;SA|Saudi Arabia|966|51 234 5678;IL|Israel|972|50-234-5678;QA|Qatar|974|3312 3456;' +
    'IN|India|91|81234 56789;CN|China|86|131 2345 6789;JP|Japan|81|90-1234-5678;KR|South Korea|82|10-2345-6789;' +
    'SG|Singapore|65|8123 4567;HK|Hong Kong|852|5123 4567;TH|Thailand|66|81 234 5678;MY|Malaysia|60|12-345 6789;' +
    'BR|Brazil|55|11 96123-4567;MX|Mexico|52|222 123 4567;AR|Argentina|54|11 2345-6789;CO|Colombia|57|321 1234567;' +
    'CL|Chile|56|9 6123 4567;GP|Guadeloupe|590|690 30 12 34;MQ|Martinique|596|696 20 12 34;RE|Réunion|262|692 12 34 56;' +
    'RU|Russia|7|912 345-67-89')
    .split(';').map(function (s) { var a = s.split('|'); return { c: a[0], name: a[1], code: a[2], ex: a[3] }; });

  /* Liste complète des indicatifs (ISO:indicatif) : disponible même sans connexion à la bibliothèque.
     Les noms de pays sont traduits par le navigateur (Intl.DisplayNames). */
  var CALLING_CODES = 'AD:376,AE:971,AF:93,AL:355,AM:374,AO:244,AR:54,AT:43,AU:61,AW:297,AZ:994,BA:387,BD:880,BE:32,BF:226,BG:359,BH:973,BI:257,BJ:229,BN:673,BO:591,BR:55,BT:975,BW:267,BY:375,BZ:501,CA:1,CD:243,CF:236,CG:242,CH:41,CI:225,CK:682,CL:56,CM:237,CN:86,CO:57,CR:506,CU:53,CV:238,CW:599,CY:357,CZ:420,DE:49,DJ:253,DK:45,DZ:213,EC:593,EE:372,EG:20,ER:291,ES:34,ET:251,FI:358,FJ:679,FK:500,FM:691,FO:298,FR:33,GA:241,GB:44,GE:995,GF:594,GH:233,GI:350,GL:299,GM:220,GN:224,GP:590,GQ:240,GR:30,GT:502,GW:245,GY:592,HK:852,HN:504,HR:385,HT:509,HU:36,ID:62,IE:353,IL:972,IN:91,IO:246,IQ:964,IR:98,IS:354,IT:39,JO:962,JP:81,KE:254,KG:996,KH:855,KI:686,KM:269,KP:850,KR:82,KW:965,LA:856,LB:961,LI:423,LK:94,LR:231,LS:266,LT:370,LU:352,LV:371,LY:218,MA:212,MC:377,MD:373,ME:382,MG:261,MH:692,MK:389,ML:223,MM:95,MN:976,MO:853,MQ:596,MR:222,MT:356,MU:230,MV:960,MW:265,MX:52,MY:60,MZ:258,NA:264,NC:687,NE:227,NF:672,NG:234,NI:505,NL:31,NO:47,NP:977,NR:674,NU:683,NZ:64,OM:968,PA:507,PE:51,PF:689,PG:675,PH:63,PK:92,PL:48,PM:508,PS:970,PT:351,PW:680,PY:595,QA:974,RE:262,RO:40,RS:381,RU:7,RW:250,SA:966,SB:677,SC:248,SD:249,SE:46,SG:65,SH:290,SI:386,SK:421,SL:232,SM:378,SN:221,SO:252,SR:597,SS:211,ST:239,SV:503,SY:963,SZ:268,TD:235,TG:228,TH:66,TJ:992,TK:690,TL:670,TM:993,TN:216,TO:676,TR:90,TV:688,TW:886,TZ:255,UA:380,UG:256,US:1,UY:598,UZ:998,VE:58,VN:84,VU:678,WF:681,WS:685,XK:383,YE:967,ZA:27,ZM:260,ZW:263'.split(',');

  /* Territoires retirés de la liste : on propose le pays principal ayant le même indicatif. */
  var KNOWN = {};
  CALLING_CODES.forEach(function (item) { KNOWN[item.split(':')[0]] = true; });

  var ALIAS = {AG:'US',AI:'US',AS:'US',AX:'FI',BB:'US',BL:'GP',BM:'US',BQ:'CW',BS:'US',CC:'AU',CX:'AU',DM:'US',DO:'US',EH:'MA',GD:'US',GG:'GB',GU:'US',IM:'GB',JE:'GB',JM:'US',KN:'US',KY:'US',KZ:'RU',LC:'US',MF:'GP',MP:'US',MS:'US',PR:'US',SJ:'NO',SX:'US',TC:'US',TT:'US',VA:'IT',VC:'US',VG:'US',VI:'US',YT:'RE'};

  function buildCountries(locale) {
    var known = {};
    BUILTIN.forEach(function (x) { known[x.c] = x; });
    var names = null;
    try { names = new Intl.DisplayNames([locale || 'en'], { type: 'region' }); } catch (e) { /* ignore */ }
    return CALLING_CODES.map(function (item) {
      var parts = item.split(':');
      var iso = parts[0];
      var fallback = known[iso] ? known[iso].name : iso;
      var name = fallback;
      if (names) { try { name = names.of(iso) || fallback; } catch (e) { name = fallback; } }
      return { c: iso, name: name, code: parts[1], ex: known[iso] ? known[iso].ex : '' };
    });
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function flag(c) {
    return String.fromCodePoint.apply(null, c.split('').map(function (ch) { return 127397 + ch.charCodeAt(0); }));
  }

  function sortFn(a, b) {
    var ca = parseInt(a.code, 10), cb = parseInt(b.code, 10);
    if (ca !== cb) return ca - cb;
    var pa = PRIO.indexOf(a.c), pb = PRIO.indexOf(b.c);
    pa = pa < 0 ? 99 : pa; pb = pb < 0 ? 99 : pb;
    if (pa !== pb) return pa - pb;
    return a.name.localeCompare(b.name);
  }

  /* ===================================================================
     <restock-alert> : bouton « Être prévenu »
     =================================================================== */
  if (!customElements.get('restock-alert')) {
    class RestockAlert extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-restock-open]');
        if (!this.button) return;
        this.sectionId = this.dataset.sectionId;
        this.variant = null;

        this.button.addEventListener('click', function (event) {
          event.preventDefault();
          var modal = document.getElementById(this.dataset.modalId);
          if (modal && typeof modal.show === 'function') modal.show(this.button, this.currentVariant());
        }.bind(this));

        // Pendant le chargement de la nouvelle variante : on masque le bouton (écoute du DOM,
        // le changement d'option n'a pas d'événement dédié fiable dans Release)
        this.onOptionChange = function (event) {
          var target = event.target;
          if (!target || !target.closest) return;
          if (!target.closest('product-info[data-section="' + this.sectionId + '"] product-variant-selects')) return;
          this.button.hidden = true;
          // filet de sécurité : si l'événement de Release ne nous parvient pas, on relit la variante dans la page
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(this.syncFromPage.bind(this), 900);
          this.syncTimerLate = setTimeout(this.syncFromPage.bind(this), 2500);
        }.bind(this);
        document.addEventListener('change', this.onOptionChange);

        // Variante chargée : le bouton apparaît seulement si elle est épuisée
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
            var data = payload && payload.data;
            if (!data || data.sectionId !== this.sectionId) return;
            clearTimeout(this.syncTimer);
            clearTimeout(this.syncTimerLate);
            this.variant = data.variant;
            this.applyVariant(data.variant);
          }.bind(this));
        }
      }

      applyVariant(variant) {
        this.button.hidden = !(variant && variant.available === false);
      }

      syncFromPage() {
        var variant = this.readVariantFromPage();
        if (variant) {
          this.variant = variant;
          this.applyVariant(variant);
        }
      }

      readVariantFromPage() {
        var node = document.querySelector('product-info[data-section="' + this.sectionId + '"] [data-selected-variant]');
        if (!node) return null;
        try { return JSON.parse(node.textContent); } catch (e) { return null; }
      }

      disconnectedCallback() {
        clearTimeout(this.syncTimer);
        clearTimeout(this.syncTimerLate);
        document.removeEventListener('change', this.onOptionChange);
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      /* Variante actuellement choisie (taille) : lue dans la page, sinon dernière connue */
      currentVariant() {
        return this.readVariantFromPage() || this.variant || { id: this.dataset.variantId, title: this.dataset.variantTitle };
      }
    }

    customElements.define('restock-alert', RestockAlert);
  }

  /* ===================================================================
     <restock-modal> : saisie du numéro et inscription Klaviyo
     =================================================================== */
  if (!customElements.get('restock-modal')) {
    class RestockModal extends ModalDialog {
      constructor() {
        super();

        this.config = JSON.parse(this.querySelector('[data-restock-config]').textContent);
        this.strings = this.config.strings;
        this.lib = null;
        this.examples = null;
        this.variant = null;
        this.selected = this.config.defaultCountry;

        this.setList(buildCountries(this.strings.country_locale));
        this.setCountry(this.selected);

        // sur mobile, le blocage du scroll de la page empêchait de faire défiler la liste des pays
        this.$('list').addEventListener('touchmove', function (event) { event.stopPropagation(); }, { passive: true });

        // Release (ModalDialog) bloque la remontée des clics depuis la boîte de dialogue :
        // on écoute donc les clics directement sur cette boîte
        this.dialogHolder.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        // Échap : ferme d'abord la liste des pays, puis la fenêtre
        this.addEventListener('keyup', function (event) {
          if (event.key === 'Escape' && this.dropdownOpen()) {
            this.closeDropdown();
            event.stopImmediatePropagation();
          }
        }.bind(this), true);
      }

      connectedCallback() {
        // supprime les copies déjà déplacées dans <body> (rechargement de la section dans l'éditeur)
        var id = this.dataset.sectionId;
        document.querySelectorAll('restock-modal[data-section-id="' + id + '"]').forEach(function (other) {
          if (other !== this) other.remove();
        }.bind(this));
        super.connectedCallback();
      }

      $(name) {
        return this.querySelector('[data-restock="' + name + '"]');
      }

      /* ---------- Ouverture ---------- */
      show(opener, variant) {
        this.variant = variant || null;
        var title = this.config.productTitle;
        var variantTitle = this.variant && this.variant.title;
        this.$('sub').textContent = title + (variantTitle && variantTitle !== 'Default Title' ? ' · ' + variantTitle : '');
        this.$('form').hidden = false;
        this.$('done').hidden = true;
        this.setError('');
        this.closeDropdown();
        super.show(opener);
        this.loadLib();
        setTimeout(function () { this.$('phone').focus(); }.bind(this), 80);
      }

      /* ---------- Événements ---------- */
      onClick(event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('[data-restock="cc-button"]')) {
          this.dropdownOpen() ? this.closeDropdown() : this.openDropdown();
          return;
        }
        var item = target.closest('.restock-item');
        if (item) {
          this.setCountry(item.getAttribute('data-c'));
          this.closeDropdown();
          this.$('phone').focus();
          return;
        }
        if (!target.closest('[data-restock="dropdown"]') && this.dropdownOpen()) this.closeDropdown();
        if (target.closest('[data-restock="submit"]')) this.submit();
      }

      onInput(event) {
        var role = event.target.getAttribute && event.target.getAttribute('data-restock');
        if (role === 'phone') {
          this.formatField(event.target, event.inputType && event.inputType.indexOf('delete') === 0);
          this.setError('');
        } else if (role === 'search') {
          this.renderList();
        }
      }

      /* ---------- Liste des pays ---------- */
      setList(arr) {
        this.list = arr.slice().sort(sortFn);
        this.byIso = {};
        this.list.forEach(function (x) { this.byIso[x.c] = x; }.bind(this));
      }

      dropdownOpen() {
        return !this.$('dropdown').hidden;
      }

      openDropdown() {
        this.$('search').value = '';
        this.renderList();
        this.$('dropdown').hidden = false;
        this.$('cc-button').setAttribute('aria-expanded', 'true');
        var selectedItem = this.$('list').querySelector('.is-sel');
        if (selectedItem) this.$('list').scrollTop = selectedItem.offsetTop - 80;
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) this.$('search').focus();
      }

      closeDropdown() {
        this.$('dropdown').hidden = true;
        this.$('cc-button').setAttribute('aria-expanded', 'false');
      }

      renderList() {
        var q = this.$('search').value.trim().toLowerCase().replace(/^\+/, '');
        var html = '';
        this.list.forEach(function (x) {
          if (q && x.name.toLowerCase().indexOf(q) < 0 && x.c.toLowerCase() !== q && x.code.indexOf(q) !== 0) return;
          html += '<li class="restock-item' + (x.c === this.selected ? ' is-sel' : '') + '" role="option" data-c="' + x.c + '">' +
            '<span>' + flag(x.c) + ' ' + esc(x.name) + '</span><span class="restock-code">+' + x.code + '</span></li>';
        }.bind(this));
        this.$('list').innerHTML = html || '<li class="restock-empty">' + esc(this.strings.no_result) + '</li>';
      }

      setCountry(c) {
        if (!this.byIso[c]) c = ALIAS[c] || 'FR';
        this.selected = c;
        this.$('cc-label').textContent = flag(c) + ' +' + this.byIso[c].code;
        this.$('phone').placeholder = this.exampleFor(c);
        if (this.$('phone').value) this.formatField(this.$('phone'));
        this.setError('');
      }

      /* ---------- Bibliothèque libphonenumber (chargée à l'ouverture) ---------- */
      loadLib() {
        if (RestockModal.libPromise) {
          RestockModal.libPromise.then(this.applyLib.bind(this));
          return RestockModal.libPromise;
        }
        var config = this.config;
        RestockModal.libPromise = new Promise(function (resolve) {
          var script = document.createElement('script');
          script.src = config.libUrl;
          script.crossOrigin = 'anonymous';
          script.onload = function () {
            var lib = window.libphonenumber;
            if (!lib || !lib.getCountries) return resolve(null);
            fetch(config.examplesUrl)
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
              .then(function (examples) { resolve({ lib: lib, examples: examples }); });
          };
          script.onerror = function () { resolve(null); };
          document.head.appendChild(script);
        });
        RestockModal.libPromise.then(this.applyLib.bind(this));
        return RestockModal.libPromise;
      }

      applyLib(loaded) {
        if (!loaded || this.lib) return;
        try {
          this.lib = loaded.lib;
          this.examples = loaded.examples;
          var names = null;
          try { names = new Intl.DisplayNames([this.strings.country_locale || 'en'], { type: 'region' }); } catch (e) { /* ignore */ }
          var previous = this.byIso;
          this.setList(this.lib.getCountries().filter(function (c) { return KNOWN[c]; }).map(function (c) {
            return {
              c: c,
              name: names ? (names.of(c) || c) : c,
              code: String(this.lib.getCountryCallingCode(c)),
              ex: (previous[c] || {}).ex
            };
          }.bind(this)));
          this.setCountry(this.selected);
          if (this.dropdownOpen()) this.renderList();
        } catch (e) { /* on garde la liste de secours */ }
      }

      /* ---------- Exemple de numéro (format international, sans l'indicatif) ---------- */
      exampleFor(c) {
        if (this.lib && this.examples) {
          try {
            var example = this.lib.getExampleNumber(c, this.examples);
            if (example) {
              var code = this.lib.getCountryCallingCode(c);
              return example.formatInternational().replace(new RegExp('^\\+' + code + '\\s*'), '');
            }
          } catch (e) { /* ignore */ }
        }
        return this.byIso[c] && this.byIso[c].ex ? this.byIso[c].ex : '';
      }

      /* ---------- Mise en forme du numéro pendant la saisie ---------- */
      groupByExample(digits, c) {
        var example = this.exampleFor(c);
        if (!example) return digits;
        var groups = example.split(/[^\d]+/).filter(Boolean).map(function (g) { return g.length; });
        var out = [], i = 0;
        for (var g = 0; g < groups.length && i < digits.length; g++) {
          var size = (g === groups.length - 1) ? digits.length - i : groups[g];
          out.push(digits.substr(i, size));
          i += size;
        }
        return out.join(' ');
      }

      formatField(el, isDelete) {
        var val = el.value;
        var pos = el.selectionStart == null ? val.length : el.selectionStart;
        var digitsBefore = val.slice(0, pos).replace(/\D/g, '').length;
        var plus = val.trim().charAt(0) === '+';
        var digits = val.replace(/\D/g, '');
        var prev = el.getAttribute('data-d') || '';

        // Retour arrière sur un espace : on supprime le chiffre qui précède
        if (isDelete && digits === prev && digitsBefore > 0) {
          digits = digits.slice(0, digitsBefore - 1) + digits.slice(digitsBefore);
          digitsBefore--;
        }

        var code = this.byIso[this.selected] ? this.byIso[this.selected].code : '';
        var national = digits;
        if (!plus && national.charAt(0) === '0') {
          national = national.slice(1);
          digitsBefore = Math.max(0, digitsBefore - 1);
        }

        var formatted = null;
        if (this.lib && this.lib.AsYouType && digits) {
          try {
            if (plus) {
              formatted = new this.lib.AsYouType().input('+' + digits);
            } else {
              formatted = new this.lib.AsYouType().input('+' + code + national).replace('+' + code, '').trim();
            }
          } catch (e) { formatted = null; }
        }
        if (formatted === null) {
          formatted = plus ? '+' + digits : this.groupByExample(national, this.selected);
        }
        if (!digits) formatted = plus ? '+' : '';

        el.value = formatted;
        el.setAttribute('data-d', plus ? digits : national);

        var count = 0, caret = 0;
        if (digitsBefore > 0) {
          for (var i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted.charAt(i))) count++;
            if (count === digitsBefore) { caret = i + 1; break; }
          }
          if (!caret) caret = formatted.length;
        } else {
          caret = plus ? 1 : 0;
        }
        try { el.setSelectionRange(caret, caret); } catch (e) { /* ignore */ }
      }

      /* ---------- Validation ---------- */
      tr(key, vars) {
        var s = this.strings[key] || '';
        for (var k in (vars || {})) s = s.split('[[' + k + ']]').join(vars[k]);
        return s;
      }

      setError(text) {
        this.$('error').textContent = text || '';
        this.$('phone').classList.toggle('is-error', !!text);
      }

      validate() {
        var S = this.strings;
        var raw = this.$('phone').value.trim();
        var c = this.selected;
        var x = this.byIso[c] || { name: c, code: '' };
        var example = this.exampleFor(c);
        var hint = example ? ' ' + this.tr('example', { example: example }) : '';
        var vars = { country: x.name, code: x.code };
        if (!raw) return { error: S.err_empty };

        if (this.lib) {
          var parsed = null;
          try { parsed = this.lib.parsePhoneNumberFromString(raw, c); } catch (e) { /* ignore */ }
          if (parsed && parsed.isValid()) {
            var type = parsed.getType();
            if (type && type !== 'MOBILE' && type !== 'FIXED_LINE_OR_MOBILE') return { error: S.err_mobile };
            return { number: parsed.number };
          }
          var length;
          try { length = this.lib.validatePhoneNumberLength(raw, c); } catch (e) { /* ignore */ }
          if (length === 'TOO_SHORT') return { error: this.tr('err_short', vars) + hint };
          if (length === 'TOO_LONG') return { error: this.tr('err_long', vars) };
          return { error: this.tr('err_invalid', vars) + hint };
        }

        // Validation de secours (bibliothèque non chargée)
        var digits = raw.replace(/\D/g, '');
        if (raw.charAt(0) === '+') {
          if (digits.indexOf(x.code) !== 0) return { error: this.tr('err_mismatch', vars) };
          digits = digits.slice(x.code.length);
        }
        if (digits.charAt(0) === '0') digits = digits.slice(1);
        var expected = example ? example.replace(/\D/g, '').replace(/^0/, '').length : 0;
        if (expected && digits.length < expected - 1) return { error: this.tr('err_short', vars) + hint };
        if (expected && digits.length > expected + 1) return { error: this.tr('err_long', vars) };
        if (digits.length < 6) return { error: this.tr('err_short', vars) + hint };
        if (digits.length > 13) return { error: this.tr('err_long', vars) };
        return { number: '+' + x.code + digits };
      }

      /* ---------- Klaviyo ---------- */
      buildBody(phone, withProperties) {
        var attributes = { phone_number: phone };
        if (withProperties) {
          attributes.properties = {
            restock_product: this.config.productTitle,
            restock_variant: this.variant ? this.variant.title : '',
            restock_variant_id: this.variant ? this.variant.id : ''
          };
        }
        return JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Restock SMS',
              profile: { data: { type: 'profile', attributes: attributes } }
            },
            relationships: { list: { data: { type: 'list', id: this.config.listId } } }
          }
        });
      }

      post(body) {
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.config.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: this.config.revision },
          body: body
        });
      }

      submit() {
        var result = this.validate();
        if (result.error) { this.setError(result.error); return; }

        var button = this.$('submit');
        var S = this.strings;
        button.disabled = true;
        button.textContent = S.sending;

        // 1re tentative avec le produit et la taille ; si Klaviyo la refuse, 2e tentative sans ces propriétés
        this.post(this.buildBody(result.number, true)).then(function (response) {
          if (response.ok) return response;
          return response.text().then(function (text) {
            console.warn('Klaviyo (avec propriétés) :', response.status, text);
            return this.post(this.buildBody(result.number, false)).then(function (response2) {
              if (response2.ok) return response2;
              return response2.text().then(function (text2) {
                console.error('Klaviyo :', response2.status, text2);
                var detail = '';
                try { detail = JSON.parse(text2).errors[0].detail; } catch (e) { /* ignore */ }
                throw new Error(detail || 'HTTP ' + response2.status);
              });
            });
          }.bind(this));
        }.bind(this)).then(function () {
          this.$('form').hidden = true;
          this.$('done').hidden = false;
        }.bind(this)).catch(function (error) {
          this.setError(S.err_generic + (error && error.message ? ' (' + error.message + ')' : ''));
        }.bind(this)).then(function () {
          button.disabled = false;
          button.textContent = S.submit;
        });
      }
    }

    customElements.define('restock-modal', RestockModal);
  }
})();